<div class="tw-flex tw-flex-col">

  @if (layer() === 1 || !stepMode) {
    <div class="tw-flex tw-flex-col tw-gap-2">
      <span class="tw-typography-body-sm tw-font-medium tw-uppercase tw-tracking-wide tw-text-main-primary"
            i18n="@@core.consent.eyebrow">Your privacy</span>
      <h2 class="tw-typography-h6 !tw-m-0 tw-text-main-primaryText" i18n="@@core.consent.l1.title">Your privacy choices</h2>
      <p class="tw-typography-body tw-text-neutral-500 !tw-m-0" i18n="@@core.consent.l1.body">
        We use analytics to improve the Letly platform and to remember where you came from so we
        can credit our partners. You choose what&apos;s on — nothing is used until you decide.
        Read our <a [href]="cookieNoticeUrl" target="_blank" rel="noopener" class="tw-text-main-primary tw-underline">Cookie Notice</a>.
      </p>
    </div>
  } @else {
    <div class="tw-flex tw-flex-col tw-gap-2">
      <letly-button
        variant="ghost"
        size="small"
        iconLeft="caret_left"
        label="Back"
        i18n-label="@@core.consent.action.back"
        class="tw-self-start"
        (click)="layer.set(1)">
      </letly-button>
      <h2 class="tw-typography-h6 !tw-m-0 tw-text-main-primaryText" i18n="@@core.consent.l2.title">
        Manage your privacy choices
      </h2>
      <p class="tw-typography-body tw-text-neutral-500 !tw-m-0" i18n="@@core.consent.l2.body">
        Turn each purpose on or off. Analytics and attribution stay off until you allow them.
      </p>
    </div>
  }

  @if (layer() === 1) {
    <div class="tw-flex tw-flex-col tw-gap-2.5 tw-mt-5">
      <div class="tw-flex tw-gap-2.5">
        <letly-button
          class="tw-flex-1"
          variant="primary"
          label="Reject all"
          i18n-label="@@core.consent.action.reject-all"
          (click)="rejectAll()">
        </letly-button>
        <letly-button
          class="tw-flex-1"
          variant="primary"
          label="Accept all"
          i18n-label="@@core.consent.action.accept-all"
          (click)="acceptAll()">
        </letly-button>
      </div>
      <letly-button
        variant="ghost"
        label="Manage options"
        i18n-label="@@core.consent.action.manage"
        (click)="layer.set(2)">
      </letly-button>
    </div>
  } @else {
    @if (!stepMode) {
      <div class="tw-h-px tw-bg-neutral-100 tw-my-5"></div>
      <span class="tw-typography-body-sm tw-font-medium tw-uppercase tw-tracking-wide tw-text-neutral-400"
            i18n="@@core.consent.l2.section-label">Manage options</span>
    }

    <div class="tw-flex tw-flex-col tw-gap-3 tw-mt-4" role="group">
      <div class="tw-flex tw-justify-between tw-items-start tw-gap-4 tw-p-4 tw-bg-neutral-50 tw-rounded-lg">
        <div class="tw-flex tw-flex-col tw-gap-1">
          <span class="tw-typography-label tw-text-main-primaryText tw-flex tw-items-center tw-gap-2">
            <ng-container i18n="@@core.consent.opt.necessary.label">Strictly necessary</ng-container>
            <span class="tw-typography-body-sm tw-uppercase tw-tracking-wide tw-text-neutral-400 tw-border tw-border-solid tw-border-neutral-200 tw-rounded-full tw-px-2"
                  i18n="@@core.consent.opt.always-on">Always on</span>
          </span>
          <span class="tw-typography-body-sm tw-text-neutral-400" i18n="@@core.consent.opt.necessary.desc">
            Keeps you signed in, secures your session, and records your consent choice. These can&apos;t be turned off.
          </span>
        </div>
        <letly-toggle-button [ngModel]="true" [disabled]="true"></letly-toggle-button>
      </div>

      <div class="tw-flex tw-justify-between tw-items-start tw-gap-4 tw-p-4 tw-bg-neutral-50 tw-rounded-lg">
        <div class="tw-flex tw-flex-col tw-gap-1">
          <span class="tw-typography-label tw-text-main-primaryText" i18n="@@core.consent.opt.analytics.label">
            Product analytics
          </span>
          <span class="tw-typography-body-sm tw-text-neutral-400" i18n="@@core.consent.opt.analytics.desc">
            Usage analytics and session replay — recordings of how you use Letly — so we can find and fix problems.
          </span>
        </div>
        <letly-toggle-button
          [ngModel]="analyticsChoice()"
          (ngModelChange)="analyticsChoice.set($event)">
        </letly-toggle-button>
      </div>

      <div class="tw-flex tw-justify-between tw-items-start tw-gap-4 tw-p-4 tw-bg-neutral-50 tw-rounded-lg">
        <div class="tw-flex tw-flex-col tw-gap-1">
          <span class="tw-typography-label tw-text-main-primaryText" i18n="@@core.consent.opt.attribution.label">
            Attribution
          </span>
          <span class="tw-typography-body-sm tw-text-neutral-400" i18n="@@core.consent.opt.attribution.desc">
            Remembers which site referred you (e.g. Zoopla, Rightmove) for up to 90 days, so we can credit our partners.
          </span>
        </div>
        <letly-toggle-button
          [ngModel]="attributionChoice()"
          (ngModelChange)="attributionChoice.set($event)">
        </letly-toggle-button>
      </div>
    </div>

    <div class="tw-flex tw-flex-col tw-gap-2.5 tw-mt-5">
      <letly-button
        variant="primary"
        label="Save choices"
        i18n-label="@@core.consent.action.save"
        (click)="saveChoices()">
      </letly-button>
      <letly-button
        variant="secondary"
        label="Accept all"
        i18n-label="@@core.consent.action.accept-all"
        (click)="acceptAll()">
      </letly-button>
    </div>
  }

</div>
